// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth-btn{cursor:pointer}.auth-btn-dark{border:transparent !important;background-color:transparent !important;color:white !important}\n", ""]);
// Exports
module.exports = exports;
